import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { MSN } from './msnTheme';

/**
 * Campo de busca - estilo MSN.
 */
export default function ChatSearchInput({ value, onChange, placeholder = 'Buscar contato...' }) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={placeholder}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: MSN.textSecondary, fontSize: 20 }} />
          </InputAdornment>
        )
      }}
      sx={{
        flexShrink: 0,
        mx: 1.5,
        mt: 1.5,
        '& .MuiOutlinedInput-root': {
          bgcolor: MSN.inputBg,
          borderRadius: 1,
          fontSize: 13,
          '& fieldset': { borderColor: MSN.border },
          color: MSN.textPrimary,
          '&:hover fieldset': { borderColor: MSN.buttonBg },
          '&.Mui-focused fieldset': { borderColor: MSN.buttonBg, borderWidth: 2 }
        },
        '& input::placeholder': { color: MSN.textMuted }
      }}
    />
  );
}
